import { Capacitor } from '@capacitor/core'
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

export const isElectron = Capacitor.getPlatform() === 'electron'
export const isAndroid = Capacitor.getPlatform() === 'android'
export const isIOS = Capacitor.getPlatform() === 'ios'

export const isMobile = useBreakpoints(breakpointsTailwind).smaller('sm')

export const isMd = useBreakpoints(breakpointsTailwind).smaller('md')
export const isLg = useBreakpoints(breakpointsTailwind).smaller('lg')
